<style lang="scss" scoped>
.dialog-info-chat__window {
  height: 68px;
  overflow-y: scroll;
}

.dialog-info-chat__input,
.dialog-info-chat__save-button {
  height: 30px;
  padding: 0 0.5rem;
}

.dialog-info-chat__save-button {
  flex-shrink: 0;
}

.dialog-info-chat__icon {
  margin: 0 5px;

  &:hover {
    cursor: pointer;
  }
}

.dialog-info-chat__message {
  transition: background-color 0.3s;
  word-break: break-all;
  overflow-wrap: break-word;

  &:hover {
    background-color: #ddd;
  }

  &--editing {
    background-color: #dcf8c7;
  }
}
</style>

<template>
  <div class="bg-danger p-2">
    <div class="text-white text-center">Wichtige Infos {{ dialogId }}</div>
    <div class="dialog-info-chat__window bg-white p-2 mb-2" ref="chat">
      <div
        v-for="message in internalMessages"
        :key="message.id"
        class="dialog-info-chat__message text-sm"
        :class="{
          'dialog-info-chat__message--editing': editingMessageId === message.id
        }"
      >
        <span v-html="getDateTime(message.created_at)"></span> -
        <span
          ><strong>{{ moderatorUsername(message) }}</strong></span
        >: <span>{{ message.text }}</span>
        <i
          v-if="!adminViewing"
          @click="toggleEditing(message)"
          class="fas dialog-info-chat__icon text-success"
          :class="editingClass(message)"
        ></i>
        <i
          v-if="!adminViewing"
          @click="deleteMessage(message)"
          class="fas fa-trash-alt text-danger dialog-info-chat__icon"
        ></i>
      </div>
    </div>
    <div class="d-flex" v-if="!adminViewing">
      <input
        class="dialog-info-chat__input mr-2 w-100"
        type="text"
        v-model="text"
        :disabled="saving"
        @keydown.enter="saveMessage"
      />
      <v-button
        class="dialog-info-chat__save-button btn-secondary"
        @click.native="saveMessage"
        :working="saving"
        :disabled="!text"
      >
        Speichern
      </v-button>
    </div>
  </div>
</template>

<script>
import { getDateTimeHtml } from "@/js/date";

export default {
  props: {
    dialogId: {
      type: Number,
      required: true
    },
    messages: {
      type: Array,
      required: true
    },
    adminViewing: {
      required: false,
      default: false,
      type: Boolean
    }
  },
  data() {
    return {
      text: null,
      saving: false,
      internalMessages: Array.from(this.messages),
      editingMessageId: null
    };
  },
  methods: {
    toggleEditing(message) {
      if (this.saving || message.deleting) {
        return;
      }

      if (this.editingMessageId === message.id) {
        this.editingMessageId = null;
        this.text = null;
      } else {
        this.editingMessageId = message.id;
        this.text = message.text;
      }
    },
    deleteMessage(messageToDelete) {
      if (messageToDelete.deleting) {
        return;
      }

      let confirmed = confirm("Nachricht löschen?");
      if (!confirmed) {
        return;
      }

      messageToDelete.deleting = true;
      if (this.editingMessageId === messageToDelete.id) {
        this.editingMessageId = null;
        this.text = null;
      }

      this.$http
        .delete(`/api/v1/dialogInfoMessage/${messageToDelete.id}`)
        .then(() => {
          let index = this.internalMessages.findIndex(
            message => message.id === messageToDelete.id
          );
          if (index >= 0) {
            this.internalMessages.splice(index, 1);
          }
          this.$notify({
            title: "Nachricht wurde gelöscht",
            type: "success"
          });
        })
        .catch(() => {
          messageToDelete.deleting = false;
        });
    },
    saveMessage() {
      if (this.saving) {
        return;
      }

      this.saving = true;

      if (this.editingMessageId) {
        this.updateMessage();
      } else {
        this.createMessage();
      }
    },
    createMessage() {
      this.$http
        .post("/api/v1/dialogInfoMessage", {
          text: this.text,
          dialog_id: this.dialogId
        })
        .then(({ data }) => {
          this.internalMessages.unshift(data);
          this.text = null;
          this.scrollToTop();
          this.$notify({
            title: "Nachricht wurde gespeichert",
            type: "success"
          });
        })
        .finally(() => {
          this.saving = false;
        });
    },
    updateMessage() {
      this.$http
        .patch(`/api/v1/dialogInfoMessage/${this.editingMessageId}`, {
          text: this.text
        })
        .then(({ data }) => {
          let index = this.internalMessages.findIndex(
            message => message.id === this.editingMessageId
          );
          if (index >= 0) {
            this.$set(this.internalMessages, index, data);
          }
          this.editingMessageId = null;
          this.text = null;
          this.$notify({
            title: "Nachricht wurde aktualisiert",
            type: "success"
          });
        })
        .finally(() => {
          this.saving = false;
        });
    },
    getDateTime(dateTime) {
      return getDateTimeHtml(dateTime);
    },
    moderatorUsername(message) {
      return message.moderator ? message.moderator.user.name : "Gelöscht";
    },
    editingClass(message) {
      return message.id === this.editingMessageId ? "fa-stop" : "fa-pen";
    },
    scrollToTop() {
      this.$nextTick(() => {
        this.$refs.chat.scrollTop = 0;
      });
    }
  },
  mounted() {
    this.scrollToTop();
  },
  watch: {
    messages() {
      this.internalMessages = Array.from(this.messages);
    }
  }
};
</script>
